<navigation [isSticky]="false"></navigation>
<div class="wrapper">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-lg-4">
        <malfunction-filter [presetSubscriptionId]="presetSubscriptionId" [presetProductType]="presetProductType">
        </malfunction-filter>
      </div>
      <div class="col-xs-12 col-lg-8">
        @if (hasFocusedSubscription()) {
          <webarchive
            [filterSubscriptionName]="filterSubscriptionName()"
            [filterSubscriptionId]="filterSubscriptionId()"
          ></webarchive>
        }

        @if (!hasFocusedSubscription() && hasTicketsAvailable()) {
          <div>
            <h3>
              {{ "Malfunction.Default.Filter.Title" | translate }}
              @if (hasFocusedProductType()) {
                {{ filterProductTypeKey() | translate }}
              }
            </h3>
          </div>
        }
        <div class="timeline" [ngClass]="{ loading: loading }">
          @for (ticket of filteredTickets(); track ticket.id) {
            <malfunction-card [message]="ticket" [showTimeElement]="isNewDate($index)"></malfunction-card>
          }
        </div>
        @if (!loading) {
          <timeline-footer [showEmptyState]="!hasTicketsAvailable()" [hasMoreResults]="hasMore"></timeline-footer>
        } @else {
          <loader />
        }
      </div>
    </div>
    <footer></footer>
  </div>
</div>
